import ActionType from '../../actions/bussiness/ActionType';


const initialState={
    bussiness_list_data:[],
    bussiness_con_data:[],
    bussiness_article_data:[],
    bussiness_zxzx_data:[],
}

const bussinessReducer=(state=initialState,action={})=>{
    switch(action.type){
        case ActionType.FETCH_BUSSINESS_LIST:
            return Object.assign({},state,{
                bussiness_list_data:action.data,
            });
        case ActionType.FETCH_BUSSINESS_CON:
            return Object.assign({},state,{
                bussiness_con_data:action.data,
            });
        case ActionType.FETCH_BUSSINESS_ARTICLE:
            return Object.assign({},state,{
                bussiness_article_data:action.data
            })
        case ActionType.FETCH_BUSSINESS_ZXZX:
            return Object.assign({},state,{
                bussiness_zxzx_data:action.data,
            });
        default:
            return state;
    }
}

export default bussinessReducer;